import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import React from 'react'

import { useAuth } from 'src/modules/auth'
import { useActionRunner } from 'src/modules/notification'
import { Button, Container, SearchInput } from 'src/modules/ui'

import { useSuppliers } from '../../../suppliers/hooks'
import RecipeList from '../RecipeList'
import RecipeFilters from '../RecipeFilters'
import { useRecipes } from '../../hooks'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('tablet')]: {
      flexDirection: 'row',
    },
  },
  filterPanel: {
    [theme.breakpoints.up('tablet')]: {
      marginRight: theme.spacing(2),
      width: 220,
    },
  },
  rightBox: {
    flexGrow: 1,
  },
  searchInput: {
    [theme.breakpoints.up('mobile')]: {
      marginLeft: theme.spacing(2),
    },
  },
  toolbar: {
    marginBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    '& > *': {
      marginBottom: theme.spacing(1),
    },
    '& > *:last-child': {
      marginBottom: 0,
    },
    [theme.breakpoints.up('mobile')]: {
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'space-between',
      '& > *': {
        marginBottom: theme.spacing(0),
      },
    },
  },
}))

export const RecipesView = ({
  fetching,
  lastPageWasSupplier,
  onFetchSuppliers,
  section,
  suppliers,
  ...props
}) => {
  const classes = useStyles()
  const { search, setSearch } = useRecipes()

  return (
    <Container className={classes.root}>
      <RecipeFilters className={classes.filterPanel} />
      <div className={classes.rightBox}>
        <div className={classes.toolbar}>
          <Button color="lightGreen" href={'/recipes/create'}>
            Create Recipe
          </Button>
          <SearchInput
            className={classes.searchInput}
            placeholder="Search recipe name..."
            size="large"
            value={search}
            onChange={setSearch}
          />
        </div>
        <RecipeList />
      </div>
    </Container>
  )
}

RecipesView.propTypes = {
  fetching: PropTypes.bool,
  lastPageWasSupplier: PropTypes.bool,
  onFetchSuppliers: PropTypes.func,
  suppliers: PropTypes.object,
}

const RecipeListView = props => {
  const { lastPageWasSupplier, fetchSuppliers, suppliers } = useSuppliers()
  const { hasPermission } = useAuth()

  // Set initial fetch status to false only if we are trying to render previous
  // supplier list
  const [fetchData, fetching] = useActionRunner(fetchSuppliers, {
    initialFetchingState: !lastPageWasSupplier,
  })

  return (
    <RecipesView
      lastPageWasSupplier={lastPageWasSupplier}
      onFetchSuppliers={fetchData}
      canRequestAgreement={hasPermission('source_suppliers')}
      canStar={hasPermission('source_suppliers')}
      fetching={fetching}
      suppliers={suppliers}
      {...props}
    />
  )
}

export default RecipeListView
